module.exports = __webpack_public_path__ + "resources/img/img_cubrid_01_jp.6ed2fb4401df8935d1dc092c129e7427.png";